import MDivider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Container = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isVip" && propName !== "isAssigned";
  },
})<{ isVip?: boolean; isAssigned?: boolean }>(({ isVip, isAssigned }) => {
  let baseColor: string;
  let textColor: string | undefined;

  if (isVip) {
    baseColor = colors.warning500;
    textColor = isAssigned ? colors.warning500 : colors.gray500;
  } else {
    baseColor = isAssigned ? colors.brandBlue500 : colors.gray500;
  }

  return {
    position: "relative",
    display: "flex",
    gap: "4px",
    top: "0",
    alignItems: "center",
    marginRight: "16px",
    marginLeft: "16px",
    marginBottom: "8px",
    maxHeight: "32px",
    color: baseColor,
    "& .task-badge__title-label": {
      color: textColor,
    },
  };
});

export const Divider = styled(MDivider)(() => ({
  backgroundColor: "currentColor",
  borderWidth: "1px",
}));

export const TitleLabel = styled("div", { name: "title-label" })(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "20px",
  cursor: "pointer",
  letterSpacing: "0.1px",
}));

export const TimeLabel = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "20px",
  cursor: "pointer",
  letterSpacing: "0.4px",
  color: colors.gray600,
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
}));
